export default {"src":"/_next/static/media/ic-launch.014ec649.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};